import template from '../../mad-id.module.scss';
import Image from 'next/image';
import animations from '@styles/animations.module.scss'
import { InView } from 'react-intersection-observer';
import style from './quote-section.module.scss'

interface IQuoteSectionProps {
    comment: string;
    authorName: string;
    authorAvatar: string;
    authorSpecialist: string;
}

const QuoteSection = ({ comment, authorName, authorAvatar, authorSpecialist }: IQuoteSectionProps) => {
    return (
        <section className={`${template.section}`}>
            <div className={`${template.container}`}>
            <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <div className={`${animations.scroll__animation} ${template.margin_bot40px}`} ref={ref}>
                                <Image alt={'quote'} width="48" height="42"
                                    src={'/mad-id-images/icons/quotes.png'} />
                            </div>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <>
                                <div ref={ref} className={`${template.text_big} ${template.text} ${template.margin_bot40px} ${animations.scroll__animation}`}>
                                    {comment}
                                </div>
                            </>
                        )
                    }}
                </InView>
                <InView triggerOnce={true}>
                    {({ inView, ref, entry }: any) => {
                        if (inView) {
                            entry.target.classList.add(animations.active);
                        }
                        return (
                            <>
                                <div ref={ref} className={`${style.quote} ${animations.scroll__animation}`}>
                                    <div className={`${style.quote__author__avatar}`}>
                                        <Image alt={authorSpecialist} layout={'fill'} sizes="200 100 50" src={authorAvatar} />
                                    </div>
                                    <div className={`${style.quote__author}`}>
                                        <div className={`${style.quote__author__name}`}>
                                            {authorName}
                                        </div>
                                        <div className={`${style.quote__author__specialist}`}>
                                            {authorSpecialist}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }}
                </InView>
            </div>
        </section>
    )
}

export default QuoteSection;